import PropTypes from 'prop-types'
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { useIntl } from 'react-intl'

const AccessibleModal = ({ children, onClose, open = false, title = null }) => {
  const { formatMessage } = useIntl()

  return (
    <Dialog
      aria-labelledby="dialog-title"
      onClose={onClose}
      open={open}
      role="alertdialog"
    >
      <IconButton
        aria-label={formatMessage({
          defaultMessage: 'Close',
          id: 'rbrahO',
        })}
        onClick={onClose}
        sx={{ position: 'absolute', right: 0 }}
      >
        <CloseRoundedIcon fontSize="small" sx={{ color: 'secondary.dark' }} />
      </IconButton>
      <DialogTitle
        component="h1"
        id="dialog-title"
        sx={{ mt: 2 }}
        tabIndex={-1}
      >
        {title}
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  )
}

AccessibleModal.propTypes = {
  children: PropTypes.any.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default AccessibleModal
